import { render, staticRenderFns } from "./VerificationForm.vue?vue&type=template&id=a633a6c2&scoped=true"
import script from "./VerificationForm.vue?vue&type=script&lang=js"
export * from "./VerificationForm.vue?vue&type=script&lang=js"
import style0 from "./VerificationForm.vue?vue&type=style&index=0&id=a633a6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a633a6c2",
  null
  
)

export default component.exports